export default __webpack_public_path__ + "static/asus-577c73af8bb2aeccf919dde76d485f2f.png";